/**
 * Icon Barrel Export File
 *
 * ⚠️ PERFORMANCE NOTE: This file exports ALL 173+ SVG icons and creates a large bundle.
 *
 * This barrel file is used by:
 * - CAIcon (dynamic icon component that needs access to all icons)
 * - Design System Icons showcase page
 *
 * 🎯 RECOMMENDED: For application code, import icons DIRECTLY from their source files:
 *
 * ✅ GOOD (tree-shakeable, optimal chunks):
 *   import SVGHome from '@icons/SVGHome.svg'
 *   import SVGUser from '@icons/SVGUser.svg'
 *
 * ❌ AVOID (bundles all 173+ icons):
 *   import { SVGHome, SVGUser } from '@icons/index'
 *   import * as Icons from '@icons/index'
 *
 * Direct imports allow Vite to:
 * - Tree-shake unused icons
 * - Create smaller, optimized chunks
 * - Load icons on-demand per route
 */

export { default as SVGAdjustments } from './SVGAdjustments.svg'
export { default as SVGAdjustmentsFilled } from './SVGAdjustments-filled.svg'
export { default as SVGAlert } from './SVGAlert.svg'
export { default as SVGAlertFilled } from './SVGAlert-filled.svg'
export { default as SVGAlertShield } from './SVGAlertShield.svg'
export { default as SVGAlertShieldFilled } from './SVGAlertShield-filled.svg'
export { default as SVGArrowDown } from './SVGArrowDown.svg'
export { default as SVGArrowLeft } from './SVGArrowLeft.svg'
export { default as SVGArrowRight } from './SVGArrowRight.svg'
export { default as SVGArrowUp } from './SVGArrowUp.svg'
export { default as SVGAssistedLivingFilled } from './SVGAssistedLiving-filled.svg'
export { default as SVGBadgeComplete } from './SVGBadgeComplete.svg'
export { default as SVGBan } from './SVGBan.svg'
export { default as SVGBank } from './SVGBank.svg'
export { default as SVGBankFilled } from './SVGBank-filled.svg'
export { default as SVGBell } from './SVGBell.svg'
export { default as SVGBellFilled } from './SVGBell-filled.svg'
export { default as SVGBolt } from './SVGBolt.svg'
export { default as SVGBoltFilled } from './SVGBolt-filled.svg'
export { default as SVGBoltSlash } from './SVGBoltSlash.svg'
export { default as SVGBoltSlashFilled } from './SVGBoltSlash-filled.svg'
export { default as SVGBook } from './SVGBook.svg'
export { default as SVGBookFilled } from './SVGBook-filled.svg'
export { default as SVGBuilding } from './SVGBuilding.svg'
export { default as SVGBuildingFilled } from './SVGBuilding-filled.svg'
export { default as SVGCalendar } from './SVGCalendar.svg'
export { default as SVGCalendarFilled } from './SVGCalendar-filled.svg'
export { default as SVGCareAcademy } from './SVGCareAcademy.svg'
export { default as SVGCareAcademyFull } from './SVGCareAcademyFull.svg'
export { default as SVGChartBar } from './SVGChartBar.svg'
export { default as SVGChartBarFilled } from './SVGChartBar-filled.svg'
export { default as SVGChat } from './SVGChat.svg'
export { default as SVGChatAlt } from './SVGChatAlt.svg'
export { default as SVGChatAltFilled } from './SVGChatAlt-filled.svg'
export { default as SVGChatFilled } from './SVGChat-filled.svg'
export { default as SVGCheck } from './SVGCheck.svg'
export { default as SVGCheckBadge } from './SVGCheckBadge.svg'
export { default as SVGCheckBadgeFilled } from './SVGCheckBadge-filled.svg'
export { default as SVGCheckCircle } from './SVGCheckCircle.svg'
export { default as SVGCheckCircleFilled } from './SVGCheckCircle-filled.svg'
export { default as SVGCheckCirclePartial } from './SVGCheckCirclePartial.svg'
export { default as SVGChevronDown } from './SVGChevronDown.svg'
export { default as SVGChevronLeft } from './SVGChevronLeft.svg'
export { default as SVGChevronRight } from './SVGChevronRight.svg'
export { default as SVGChevronUp } from './SVGChevronUp.svg'
export { default as SVGCircleX } from './SVGCircleX.svg'
export { default as SVGCircleXFilled } from './SVGCircleX-filled.svg'
export { default as SVGClipboardCheckmark } from './SVGClipboardCheckmark.svg'
export { default as SVGClipboardCheckmarkFilled } from './SVGClipboardCheckmark-filled.svg'
export { default as SVGClock } from './SVGClock.svg'
export { default as SVGClockFilled } from './SVGClock-filled.svg'
export { default as SVGClose } from './SVGClose.svg'
export { default as SVGCloud } from './SVGCloud.svg'
export { default as SVGCloudDownload } from './SVGCloudDownload.svg'
export { default as SVGCloudDownloadFilled } from './SVGCloudDownload-filled.svg'
export { default as SVGCloudFilled } from './SVGCloud-filled.svg'
export { default as SVGCloudUpload } from './SVGCloudUpload.svg'
export { default as SVGCloudUploadFilled } from './SVGCloudUpload-filled.svg'
export { default as SVGComplianceFilled } from './SVGCompliance-filled.svg'
export { default as SVGComplianceStatusFilled } from './SVGComplianceStatus-filled.svg'
export { default as SVGComponents } from './SVGComponents.svg'
export { default as SVGComponentsFilled } from './SVGComponents-filled.svg'
export { default as SVGContainers } from './SVGContainers.svg'
export { default as SVGContainersFilled } from './SVGContainers-filled.svg'
export { default as SVGContinuingCareCommunityFilled } from './SVGContinuingCareCommunity-filled.svg'
export { default as SVGCopy } from './SVGCopy.svg'
export { default as SVGCopyFilled } from './SVGCopy-filled.svg'
export { default as SVGCreditCard } from './SVGCreditCard.svg'
export { default as SVGCreditCardFilled } from './SVGCreditCard-filled.svg'
export { default as SVGDocument } from './SVGDocument.svg'
export { default as SVGDocumentFilled } from './SVGDocument-filled.svg'
export { default as SVGDot } from './SVGDot.svg'
export { default as SVGDotsCircleHorizontal } from './SVGDotsCircleHorizontal.svg'
export { default as SVGDotsCircleHorizontalFilled } from './SVGDotsCircleHorizontal-filled.svg'
export { default as SVGDotsHorizontal } from './SVGDotsHorizontal.svg'
export { default as SVGDownload } from './SVGDownload.svg'
export { default as SVGEdit } from './SVGEdit.svg'
export { default as SVGEditFilled } from './SVGEdit-filled.svg'
export { default as SVGEnvelope } from './SVGEnvelope.svg'
export { default as SVGEnvelopeFilled } from './SVGEnvelope-filled.svg'
export { default as SVGExclamationMarkCircle } from './SVGExclamationMarkCircle.svg'
export { default as SVGExclamationMarkCircleFilled } from './SVGExclamationMarkCircle-filled.svg'
export { default as SVGExternalLink } from './SVGExternalLink.svg'
export { default as SVGEye } from './SVGEye.svg'
export { default as SVGEyeFilled } from './SVGEye-filled.svg'
export { default as SVGFilter } from './SVGFilter.svg'
export { default as SVGFilterFilled } from './SVGFilter-filled.svg'
export { default as SVGFlag } from './SVGFlag.svg'
export { default as SVGFlagFilled } from './SVGFlag-filled.svg'
export { default as SVGFolder } from './SVGFolder.svg'
export { default as SVGFolderAdd } from './SVGFolderAdd.svg'
export { default as SVGFolderAddFilled } from './SVGFolderAdd-filled.svg'
export { default as SVGFolderFilled } from './SVGFolder-filled.svg'
export { default as SVGFolderOpen } from './SVGFolderOpen.svg'
export { default as SVGFolderOpenFilled } from './SVGFolderOpen-filled.svg'
export { default as SVGFolderRemove } from './SVGFolderRemove.svg'
export { default as SVGFolderRemoveFilled } from './SVGFolderRemove-filled.svg'
export { default as SVGForward } from './SVGForward.svg'
export { default as SVGForwardFilled } from './SVGForward-filled.svg'
export { default as SVGGraduationCap } from './SVGGraduationCap.svg'
export { default as SVGGraduationCapFilled } from './SVGGraduationCap-filled.svg'
export { default as SVGHamburger } from './SVGHamburger.svg'
export { default as SVGHome } from './SVGHome.svg'
export { default as SVGHomeCareFilled } from './SVGHomeCare-filled.svg'
export { default as SVGHomeFilled } from './SVGHome-filled.svg'
export { default as SVGHomeHealthFilled } from './SVGHomeHealth-filled.svg'
export { default as SVGHomeHospiceFilled } from './SVGHomeHospice-filled.svg'
export { default as SVGIdentification } from './SVGIdentification.svg'
export { default as SVGIdentificationFilled } from './SVGIdentification-filled.svg'
export { default as SVGIndependentLivingFilled } from './SVGIndependentLiving-filled.svg'
export { default as SVGInfo } from './SVGInfo.svg'
export { default as SVGInfoFilled } from './SVGInfo-filled.svg'
export { default as SVGLayout } from './SVGLayout.svg'
export { default as SVGLayoutFilled } from './SVGLayout-filled.svg'
export { default as SVGLibraryBuilding } from './SVGLibraryBuilding.svg'
export { default as SVGLibraryBuildingFilled } from './SVGLibraryBuilding-filled.svg'
export { default as SVGLightBulb } from './SVGLightBulb.svg'
export { default as SVGLightBulbFilled } from './SVGLightBulb-filled.svg'
export { default as SVGLoading } from './SVGLoading.svg'
export { default as SVGLocation } from './SVGLocation.svg'
export { default as SVGLocationFilled } from './SVGLocation-filled.svg'
export { default as SVGLock } from './SVGLock.svg'
export { default as SVGLockFilled } from './SVGLock-filled.svg'
export { default as SVGMap } from './SVGMap.svg'
export { default as SVGMapFilled } from './SVGMap-filled.svg'
export { default as SVGMinus } from './SVGMinus.svg'
export { default as SVGMobilePhoneFilled } from './SVGMobilePhone-filled.svg'
export { default as SVGNotifications } from './SVGNotifications.svg'
export { default as SVGNotificationsFilled } from './SVGNotifications-filled.svg'
export { default as SVGOpenBook } from './SVGOpenBook.svg'
export { default as SVGOpenBookFilled } from './SVGOpenBook-filled.svg'
export { default as SVGPause } from './SVGPause.svg'
export { default as SVGPauseFilled } from './SVGPause-filled.svg'
export { default as SVGPencil } from './SVGPencil.svg'
export { default as SVGPencilFilled } from './SVGPencil-filled.svg'
export { default as SVGPlus } from './SVGPlus.svg'
export { default as SVGPlusCircle } from './SVGPlusCircle.svg'
export { default as SVGPlusCircleFilled } from './SVGPlusCircle-filled.svg'
export { default as SVGQuestion } from './SVGQuestion.svg'
export { default as SVGQuestionFilled } from './SVGQuestion-filled.svg'
export { default as SVGRefresh } from './SVGRefresh.svg'
export { default as SVGRemindersFilled } from './SVGReminders-filled.svg'
export { default as SVGReply } from './SVGReply.svg'
export { default as SVGRewind } from './SVGRewind.svg'
export { default as SVGRewindFilled } from './SVGRewind-filled.svg'
export { default as SVGSave } from './SVGSave.svg'
export { default as SVGSaveFilled } from './SVGSave-filled.svg'
export { default as SVGSearch } from './SVGSearch.svg'
export { default as SVGSelector } from './SVGSelector.svg'
export { default as SVGSend } from './SVGSend.svg'
export { default as SVGSendFilled } from './SVGSend-filled.svg'
export { default as SVGShare } from './SVGShare.svg'
export { default as SVGShareFilled } from './SVGShare-filled.svg'
export { default as SVGSimpleDropdown } from './SVGSimpleDropdown.svg'
export { default as SVGSkilledNursingFacilityFilled } from './SVGSkilledNursingFacility-filled.svg'
export { default as SVGSortAscending } from './SVGSortAscending.svg'
export { default as SVGSortDescending } from './SVGSortDescending.svg'
export { default as SVGSparkles } from './SVGSparkles.svg'
export { default as SVGSparklesFilled } from './SVGSparkles-filled.svg'
export { default as SVGStar } from './SVGStar.svg'
export { default as SVGStarFilled } from './SVGStar-filled.svg'
export { default as SVGSwitch } from './SVGSwitch.svg'
export { default as SVGSwitchVertical } from './SVGSwitchVertical.svg'
export { default as SVGTables } from './SVGTables.svg'
export { default as SVGTablesFilled } from './SVGTables-filled.svg'
export { default as SVGTag } from './SVGTag.svg'
export { default as SVGTagFilled } from './SVGTag-filled.svg'
export { default as SVGTemplate } from './SVGTemplate.svg'
export { default as SVGTemplateFilled } from './SVGTemplate-filled.svg'
export { default as SVGTranslate } from './SVGTranslate.svg'
export { default as SVGTranslateFilled } from './SVGTranslate-filled.svg'
export { default as SVGTrash } from './SVGTrash.svg'
export { default as SVGTrashFilled } from './SVGTrash-filled.svg'
export { default as SVGUpload } from './SVGUpload.svg'
export { default as SVGUser } from './SVGUser.svg'
export { default as SVGUserAdd } from './SVGUserAdd.svg'
export { default as SVGUserAddFilled } from './SVGUserAdd-filled.svg'
export { default as SVGUserCircle } from './SVGUserCircle.svg'
export { default as SVGUserCircleFilled } from './SVGUserCircle-filled.svg'
export { default as SVGUserFilled } from './SVGUser-filled.svg'
export { default as SVGUserGroup } from './SVGUserGroup.svg'
export { default as SVGUserGroupFilled } from './SVGUserGroup-filled.svg'
export { default as SVGUserMinus } from './SVGUserMinus.svg'
export { default as SVGUserMinusFilled } from './SVGUserMinus-filled.svg'
export { default as SVGUsers } from './SVGUsers.svg'
export { default as SVGUsersFilled } from './SVGUsers-filled.svg'
export { default as SVGVideoCamera } from './SVGVideoCamera.svg'
export { default as SVGVideoCameraFilled } from './SVGVideoCamera-filled.svg'
